import { Icon, DateTools } from '@treezor/design-system';

import { TComputedKycDocument } from '@/features/kyc/store/models/kyc.model';
import { useKycDocuments } from '@/features/kyc/hooks/useKycDocuments';
import { KycDocumentStatusLabel } from '@/features/kyc/components/kyc-documents/KycDocumentStatusLabel';
import { KycDocumentActions } from '@/features/kyc/components/kyc-documents/KycDocumentActions';

type TKycDocumentListItemProps = {
  document: TComputedKycDocument;
  hasActions?: boolean;
  isLoading?: boolean;
};

export function KycDocumentListItem({ document, hasActions = true, isLoading }: TKycDocumentListItemProps) {
  const { documentTranslation } = useKycDocuments();

  return (
    <div className="flex items-center justify-between">
      <div className="flex gap-3 items-start">
        <Icon name="draft" isFill={false} size="s" className="text-icon-info" />
        <div className="flex flex-col">
          <span className="typo-body-regular-small text-secondary">
            {documentTranslation(Number(document.documentType))}
          </span>
          <span className="typo-body-regular-caption text-tertiary">
            {`Created on ${DateTools.format(document.createdAt, 'date-time') || ' - '}`}
          </span>
        </div>
      </div>

      <div className="flex gap-3 items-center">
        <KycDocumentStatusLabel status={document.kycStatus} />
        {hasActions && <KycDocumentActions document={document} isLoading={isLoading} />}
      </div>
    </div>
  );
}
